export const PLANS_QUERY_DEFAULTS = {
  SORT_BY: 'deposit_date',
  SORT_ORDER: 'desc' as const,
  FILTER: 'all',
  LIMIT: 100,
} as const

export const STORAGE_KEY = 'dashboard-plans'

export const VALIDATION_LIMITS = {
  SEARCH_MAX_LENGTH: 100,
} as const

export const VALIDATION_PATTERNS = {
  SEARCH_INPUT: /^(?:(?!\p{Default_Ignorable_Code_Point})[\p{L}\p{M}\p{N}_\s\-@.+=,:'’])*$/u,
} as const

export const VALID_SORT_BY_OPTIONS = [
  'deposit_date',
  'departure_date',
  'customer_name',
  'booking_reference',
  'total_amount',
  'status',
] as const

export const VALID_FILTER_OPTIONS = [
  'all',
  'in-full',
  'active',
  'ontrack',
  'suspended',
  'late0d',
  'late7d',
  'late14d',
  'lossrecovery',
  'halted',
  'completed',
] as const

export const PERMISSIONS = {
  VIEW_PLANS: 'view:plans',
} as const
